const TYPE_STRING = "[object String]";
const TYPE_OBJECT = "[object Object]";
const TYPE_NUMBER = "[object Number]";
const TYPE_BOOLEAN = "[object Boolean]";
const TYPE_FUNCTION = "[object Function]";
const ESTypes = {
  string: TYPE_STRING,
  object: TYPE_OBJECT,
  number: TYPE_NUMBER,
  boolean: TYPE_BOOLEAN,
  function: TYPE_FUNCTION
};
const TYPE_UNDEFINED = "undefined";
const CDNWhiteList = [
  "img01.weeecdn.com",
  "img07.weeecdn.net",
  // Cloudflare 映射 img01.weeecdn.com
  "img06.weeecdn.com",
  "img08.weeecdn.net",
  // Cloudflare 映射 img06.weeecdn.com
  "video.sayweeecdn.com",
  "cdn.sayweee.net",
  "cdn01.sayweee.net",
  "images-static.sayweeecdn.com",
  "img01.sayweeecdn.com",
  "images01.sayweeecdn.com",
  "dev.sayweeecdn.com",
  "img06.test.weeecdn.com",
  "static.weeecdn.com",
  "static.weeecdn.net",
  // Cloudflare 映射 static.weeecdn.com
  "img.test.weeecdn.com"
];
var ImgLoadStatus = /* @__PURE__ */ ((ImgLoadStatus2) => {
  ImgLoadStatus2["loading"] = "loading";
  ImgLoadStatus2["loaded"] = "loaded";
  ImgLoadStatus2["loadError"] = "loadError";
  return ImgLoadStatus2;
})(ImgLoadStatus || {});
export {
  CDNWhiteList,
  ESTypes,
  ImgLoadStatus,
  TYPE_UNDEFINED
};
//# sourceMappingURL=constants.js.map
